// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusProductListStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusProductList";
import { LinesHeaderStyles } from "@werner/App/Components/Cart/LinesHeader";
import cartPageStyles from "@werner/App/SharedStyle/CartPageStyles";
import orderDetailsSharedStyles from "@werner/App/SharedStyle/OrderDetailsSharedStyles";
import { mergeWithCss } from "@werner/XDL/Utilities";
import { css } from "styled-components";

orderStatusProductListStyles.orderLines = {
    linesHeaderStyles: {
        ...orderDetailsSharedStyles.linesHeaderStyles,
        priceUnit: {
            css: css`
                flex: 1;
                text-align: left;
                @media print {
                    word-break: initial;
                }
            `,
        },
        qty: {
            css: css`
                flex: 1;
                @media print {
                    flex: none;
                    width: 100px;
                    text-align: left;
                    word-break: initial;
                }
            `,
        },
    } as LinesHeaderStyles,
    priceHeadingAndText: {
        ...cartPageStyles.cartLine?.totalSmallHeadingAndText,
        text: {
            ...mergeWithCss(cartPageStyles.cartLine?.totalSmallHeadingAndText?.text, {
                css: css`
                    text-align: left;
                    padding-right: 0;
                `,
            }),
        },
        heading: {
            ...mergeWithCss(cartPageStyles.cartLine?.totalSmallHeadingAndText?.heading, {
                css: css`
                    text-align: left;
                `,
            }),
        },
    },
} as any;
